<button
  *ngIf="grid['isFilterButtonShown']"
  [matMenuTriggerFor]="filterMenu"
  (click)="loadClientFilters()"
  mat-button
  title="{{'grid_filter.menu.menu_tooltip' | translate}}"
  type="button"><i class="fa fa-bars"></i>
</button>

<mat-menu #filterMenu="matMenu">
  <mat-list>
    <h3 matSubheader>{{'grid_filter.menu.saved_filters' | translate}}</h3>
    <div class="prod-grid-filter-list">
      <mat-list-item *ngFor="let clientFilter of clientFilters"><i class="ml-1 mr-1 fa" [ngClass]="clientFilter.user !== null ? 'fa-user' : 'fa-users'"></i>
        <button (click)="activate(clientFilter)" class="mat-menu-item">{{clientFilter.name}}</button>
      </mat-list-item>
    </div>
    <mat-divider></mat-divider>
    <mat-list-item>
      <button (click)="openDialog()"
              class="ml-1 mat-menu-item"
              title="{{'grid_filter.menu.management.tooltip' | translate}}"><i class="fa fa-filter"></i> {{'grid_filter.menu.management.text' | translate}}
      </button>
    </mat-list-item>
    <mat-list-item>
      <button (click)="restore()" class="ml-1 mat-menu-item"
              title="{{'grid_filter.menu.reset.tooltip' | translate}}"><i
        class="fa fa-columns"></i> {{'grid_filter.menu.reset.text' | translate}}
      </button>
    </mat-list-item>
  </mat-list>
</mat-menu>
